import type { PagesConfig } from '#types/config/pages'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    heading: 'subtitle-4'
  },
  showLoginForm: true
} satisfies RecursivePartial<PagesConfig['orderStatus']>
